<script lang="ts" setup>
	import { Settings, User, LogOut } from 'lucide-vue-next'
	import { computed } from 'vue'
	import { useAuthStore } from '@/stores/auth.store'
	import type { IUser } from '@/stores/auth.store'
	import Popper from 'vue3-popper'
	import { RouterLink } from 'vue-router'
	import { useI18n } from 'vue-i18n'
	import { _translations } from './_translations'

	const authStore = useAuthStore()
	const { t } = useI18n(_translations)

	const user = computed<IUser | null>(() => authStore.user)
</script>

<template>
	<Popper placement="bottom-end" offsetDistance="8" :showArrow="false">
		<button class="btn btn-ghost rounded-btn px-1.5">
			<div class="flex items-center gap-2">
				<div class="avatar">
					<div class="bg-secondary mask mask-squircle flex h-8 w-8 items-center justify-center">
						<div class="text-base-content text-sm leading-8 font-bold">
							{{ user?.firstname?.charAt(0) }}{{ user?.lastname?.charAt(0) }}
						</div>
					</div>
				</div>
				<div class="-space-y-0.5 text-start">
					<div class="text-sm">{{ user?.firstname }} {{ user?.lastname }}</div>
					<small class="text-base-content/60 text-xs">{{ user?.email }}</small>
				</div>
			</div>
		</button>

		<template #content="{ close }">
			<div class="bg-base-100 rounded-box z-[10000] w-44 shadow">
				<ul class="menu w-full p-2">
					<li>
						<RouterLink :to="{ name: 'AuthUserProfile' }" @click="close()">
							<User />
							<span>{{ t('layout.userMenu.profile') }}</span>
						</RouterLink>
					</li>
					<li>
						<div>
							<Settings />
							<span>{{ t('layout.userMenu.settings') }}</span>
						</div>
					</li>
				</ul>
				<hr class="border-base-300" />
				<ul class="menu w-full p-2">
					<li>
						<button class="text-error hover:bg-error/10" @click="authStore.signOut()">
							<LogOut size="20" />
							<span>{{ t('layout.userMenu.logout') }}</span>
						</button>
					</li>
				</ul>
			</div>
		</template>
	</Popper>
</template>
